import {
  IonBackButton,
  IonButtons,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonToast,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { setEmail, setInitialData, setWhatsapp } from "../../store/MassNotification";
import { logoWhatsapp, mailOutline, peopleOutline } from "ionicons/icons";
import { PeopleSelector } from "./components/PeopleSelector";
import { PeopleSelected } from "./components/PeopleSelected";
import { ConfirmButton } from "./components/ConfirmButton";
import { findPeople } from "../../store/MassNotification/actions/findPeople";
import { useHistory } from "react-router";
import { findDocumentsTypes } from "../../store/MassNotification/actions/findDocumentTypes";
import { findTotalPeople } from "../../store/MassNotification/actions/findTotalPeople";

const checkboxTextStyle = {
  fontSize: 13,
  fontWeight: "bold",
  verticalAlign: "middle",
};

const checkboxIconStyle = {
  paddingLeft: 5,
  fontSize: 25,
  fontWeight: "bold",
  verticalAlign: "middle",
};

const checkboxStyle = {
  verticalAlign: "middle",
};

const divChannelsSelector = {
  paddingLeft: "25px",
  paddingRight: "10px",
};

export const SpecificMassNotification = () => {
  const [selectorActive, setSelectorActive] = useState<boolean>(true);
  const dispatch = useDispatch();
  const history = useHistory();
  const state = useSelector((state: RootState) => state.massNotification);

  useEffect(() => {
    dispatch(findPeople());
  }, []);

  const handleNotificationDismiss = () => {
    dispatch(setInitialData());
    dispatch(findDocumentsTypes());
    dispatch(findTotalPeople());
    history.replace(`/app/rrhh/acuerdos/notificacion-masiva`);
  };

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "" : ""}
              defaultHref={"/app/rrhh/acuerdos/notificacion-masiva"}
              color="light"
            />
          </IonButtons>
          <IonButtons slot="end">
            <IonRow style={{ display: "flex", justifyContent: "end", padding: "10px" }}>
              <div>
                <IonCheckbox
                  style={checkboxStyle}
                  checked={state.email}
                  onIonChange={(e) => dispatch(setEmail(e.detail.checked))}
                />{" "}
                <IonIcon icon={mailOutline} style={checkboxIconStyle} className="ion-hide-md-up" />
                <span style={checkboxTextStyle} className="ion-hide-md-down">
                  &nbsp;CORREO ELECTRÓNICO
                </span>
              </div>
              <div style={divChannelsSelector}>
                <IonCheckbox
                  style={checkboxStyle}
                  checked={state.whatsapp}
                  onIonChange={(e) => dispatch(setWhatsapp(e.detail.checked))}
                />{" "}
                <IonIcon icon={logoWhatsapp} style={checkboxIconStyle} className="ion-hide-md-up" />
                <span style={checkboxTextStyle} className="ion-hide-md-down">
                  &nbsp;WHATSAPP
                </span>
              </div>
            </IonRow>
            <ConfirmButton />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <section className={"ion-margin"}>
          <IonText color="primary">
            <h2>Notificaciones Masivas Específicas</h2>
          </IonText>
          <IonGrid class="ion-no-margin ion-no-padding">
            {/* Inicio - Para móviles */}
            <IonRow className="ion-hide-md-up">
              <IonSegment
                value={selectorActive ? "disponibles" : "seleccionados"}
                color="secondary"
                style={{
                  maxWidth: "100%",
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  backgroundColor: "white",
                  zIndex: 1000,
                }}
              >
                <IonSegmentButton
                  value="disponibles"
                  onClick={() => {
                    setSelectorActive(true);
                  }}
                >
                  <IonLabel>Disponibles</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton
                  value="seleccionados"
                  onClick={() => {
                    setSelectorActive(false);
                  }}
                >
                  <IonLabel>Seleccionados</IonLabel>
                </IonSegmentButton>
              </IonSegment>
              <IonCol style={{ paddingLeft: 0, paddingRight: 6 }}>
                {selectorActive ? <PeopleSelector /> : <PeopleSelected />}
              </IonCol>
              <IonFooter style={{ height: "2rem" }} className="ion-no-border"></IonFooter>
            </IonRow>
            {/* Fin - Para móviles */}
            {/* Inicio - para desktop */}
            <IonRow className="ion-hide-md-down">
              <IonGrid class="ion-no-margin ion-no-padding">
                <IonRow>
                  <IonCol size="6" style={{ paddingLeft: 0, paddingRight: 6 }}>
                    <PeopleSelector />
                  </IonCol>
                  <IonCol size="6" style={{ paddingRight: 0, paddingLeft: 6 }}>
                    <PeopleSelected />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonRow>
            {/* Fin - Para desktop */}
          </IonGrid>
        </section>
      </IonContent>
      {state.sendPeopleNotificationStatus === "pending" && (
        <IonToast
          isOpen={true}
          onDidDismiss={() => {}}
          message="Enviando solicitud de notificación"
          position="bottom"
          duration={3000}
          color="primary"
        />
      )}
      {state.sendPeopleNotificationStatus === "succeeded" && (
        <IonToast
          isOpen={true}
          onDidDismiss={handleNotificationDismiss}
          message="La solicitud de notificación fue enviada correctamente"
          position="bottom"
          duration={3000}
          color="success"
        />
      )}
      {state.sendPeopleNotificationStatus === "failed" && (
        <IonToast
          isOpen={true}
          onDidDismiss={() => {}}
          message="Ocurrió un error en la solicitud de notificación"
          position="bottom"
          duration={3000}
          color="danger"
        />
      )}
    </IonPage>
  );
};
